import { createAction, props } from '@ngrx/store';
import { Role, User, UserRole } from '../models/user-role.model';
import { IUserProfileFormModel } from '@carm/features/private/accounts-and-profiles/features/user-profile/models/user-profile-form.model';

export const loadRoles = createAction(
  '[User-Role] Load Roles',
);

// export const updateRoles = createAction(
//   '[User-Role] Update Roles',
//   props<{ user: User, role: UserRole }>(),
// );

export const loadNativeRoles = createAction(
  '[User-Role] Load Native Roles',
   props<{ data: { businessId: string} }>(),
);

export const loadNativeRolesSuccess = createAction(
  '[User-Role] Load Native Roles Succcess',
   props<{ data: { roles: Role[]} }>(),
);

export const loadNativeRolesFailure = createAction(
  '[User-Role] Load Native Roles Failure',
    props<{ error: any }>(),
);

export const loadRoleByBusiness = createAction(
  '[User-Role] Load Roles By Business',
  props<{ data: { businessId: string} }>(),
);

export const loadRoleByBusinessProgram = createAction(
  '[User-Role] Load Roles By Business and Program',
  props<{ data: { businessId: string, programId: string} }>(),
);

export const loadRolesByBusinessProgramSuccess = createAction(
  '[User-Role] Load Roles By BusinessProgram Success',
  props<{ data: { role: UserRole, user: User} }>(),
);

export const loadRolesByBusinessProgramFailure = createAction(
  '[User-Role] Load Roles By BusinessProgram Failure',
  props<{ error: any }>(),
);

export const loadRolesSuccess = createAction(
  '[User-Role] Load Roles Success',
  props<{ data: { role: UserRole, user: User} }>(),
);

export const loadRolesFailure = createAction(
  '[User-Role] Load Roles Failure',
  props<{ error: any }>(),
);

export const setCurrentRole = createAction(
  '[User-Role] Set Current Roles',
  props<{ data: Role }>(),
);

// export const changeCurrentProgramByUid = createAction(
//   '[User-Role] Change Current Program By ProgramUid',
//   props<{ data: string, redirect: string }>(),
// );

export const clearUserInformation = createAction(
  '[User-Role] Clear Roles',
);

export const updateIsDefaultAddressExist = createAction(
  '[User-Role] Update IsDefault AddressExist',
  props<{ defaultExists: boolean, data: IUserProfileFormModel }>(),
);

export const toggleProgramMenu = createAction(
  '[User-Role] Toggle Program Menu',
  props<{ data: boolean }>(),
);

export const setTermConditionAccepted = createAction(
  '[User-TC] Set Term Condition Accepted'
);

export const setTermConditionAPIAccepted = createAction(
  '[User-TC] Set Term Condition API Accepted'
);
